import { render, staticRenderFns } from "./partner_detail_base_religion.vue?vue&type=template&id=04f8a402&scoped=true"
import script from "./partner_detail_base_religion.vue?vue&type=script&lang=js"
export * from "./partner_detail_base_religion.vue?vue&type=script&lang=js"
import style0 from "./partner_detail_base_religion.vue?vue&type=style&index=0&id=04f8a402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f8a402",
  null
  
)

export default component.exports